<template>
<body>
  <cursor-fx ref="cursor" color="#6B4000" color-hover="#FA9732" inside-size="15px" outside-size="90px"></cursor-fx>
  <div class="all_box">

    <div class="apply_btn_box">
      <router-link to="ApplicationForm">
        <btn class="apply_btn" data-cursor-hover>
          応募する
        </btn>
      </router-link>
    </div>
    <div class="cb" />

    <div class="title_box">
      <div>
        <div class="title_h1 en_font">Infographics</div>
        <div class="title_h2 jp_font">数字で見るHES</div>
      </div>
    </div>
  </div>

  <div class="all_box">
    <div class="Portal_box">
      <div class="Portal_contents jp_font">


        <div style="padding-top:50px;" />
        <div class="infographics_title">
          <div class="infographics_chara" id="">売上</div>
        </div>
        <div class="infographics_box">
          <div class="infographics_card infographics_card_1 infographics_Animation1">
            <!-- <svg_elements name="graph_sales" class="infographics_icon3" /> -->
            <img v-lazy="require('@/assets/png/graph_sales.png')" class="infographics_icon3" />
            
          

          </div>

          <div class="cb" />
          <div style="padding-top:30px;" />

          <div class="infographics_card_2_L_box">
            <div class="infographics_title">
              <div class="infographics_chara" id="">従業員数</div>
            </div>
            <div class="infographics_card infographics_card_2 infographics_Animation2">
              <!-- <svg_elements name="graph_employees" class="infographics_icon" /> -->
              <img v-lazy="require('@/assets/png/graph_employees.png')" class="infographics_icon" />
            </div>
          </div>

          <div class="infographics_card_2_R_box">
            <div class="infographics_title">
              <div class="infographics_chara" id="">平均年齢</div> 
            </div>
            <div class="infographics_card infographics_card_2 infographics_Animation3">
              <!-- <svg_elements name="graph_age" class="infographics_icon" /> -->
              <img v-lazy="require('@/assets/png/graph_age.png')" class="infographics_icon" />
              
            </div>
          </div>

          <div class="cb" />
          <div style="padding-top:30px;" />

          <div class="infographics_card_2_L_box">
            <div class="infographics_title">
              <div class="infographics_chara" id="">男女比</div>
            </div>
            <div class="infographics_card infographics_card_2 infographics_Animation4">
              <!-- <svg_elements name="graph_1" class="infographics_icon2" /> -->
              <img v-lazy="require('@/assets/png/graph_1.png')" class="infographics_icon2" />
              
            </div>
          </div>

          <div class="infographics_card_2_R_box">
            <div class="infographics_title">
              <div class="infographics_chara" id="">世代別比</div> 
            </div>
            <div class="infographics_card infographics_card_2 infographics_Animation5">
              <!-- <svg_elements name="graph_2" class="infographics_icon2" /> -->
              <img v-lazy="require('@/assets/png/graph_2.png')" class="infographics_icon2" />
              
            </div>
          </div>

          <div class="cb" />
          <div style="padding-top:50px;" />
            
          <div class="infographics_box">

            <div class="infographics_card_3_box">
              <div class="infographics_title">
                <div class="infographics_chara" id="">2024年度</div>
              </div>
              <div class="infographics_card_3 infographics_Animation8">
                <div class="infographics_card_subtitle">新卒・中途採用率</div>
                <!-- <svg_elements name="graph_3" class="infographics_icon" /> -->
                <img v-lazy="require('@/assets/png/graph_8.png')" class="infographics_icon" />
                <svg_elements name="infographics6" class="infographics_icon" />
                <div class="infographics_card_subtitle">男女別・年齢階層別</div>
                <div class="infographics_card_subtitle">採用分布</div>
                <!-- <svg_elements name="graph_6" class="infographics_icon2" /> -->
                <img v-lazy="require('@/assets/png/graph_9.png')" class="infographics_icon2" />
              </div>
            </div>

            <div class="infographics_card_3_box">
              <div class="infographics_title">
                <div class="infographics_chara" id="">2023年度</div>
              </div>
              <div class="infographics_card_3 infographics_Animation7">
                <div class="infographics_card_subtitle">新卒・中途採用率</div>
                <!-- <svg_elements name="graph_3" class="infographics_icon" /> -->
                <img v-lazy="require('@/assets/png/graph_4.png')" class="infographics_icon" />

                <div class="infographics_card_subtitle">男女別・年齢階層別</div>
                <div class="infographics_card_subtitle">採用分布</div>
                <!-- <svg_elements name="graph_4" class="infographics_icon2" /> -->
                <img v-lazy="require('@/assets/png/graph_5.png')" class="infographics_icon2" />
              </div>
            </div>

            <div class="infographics_card_3_box">
              <div class="infographics_title">
                <div class="infographics_chara" id="">2022年度</div>
              </div>
              <div class="infographics_card_3 infographics_Animation6">
                <div class="infographics_card_subtitle">新卒・中途採用率</div>
                <!-- <svg_elements name="graph_3" class="infographics_icon" /> -->
                <img v-lazy="require('@/assets/png/graph_3.png')" class="infographics_icon" />
                <!-- <svg_elements name="infographics5" class="infographics_icon" /> -->
                
                <div class="infographics_card_subtitle">男女別・年齢階層別</div>
                <div class="infographics_card_subtitle">採用分布</div>
                <!-- <svg_elements name="graph_5" class="infographics_icon2" /> -->
                <img v-lazy="require('@/assets/png/graph_6.png')" class="infographics_icon2" />
              </div>
            </div>
          </div>
        </div>
        <div class="cb" />

        

        <div style="padding-top:150px;" />

      </div>
    </div>
  </div>
</body>
</template>


<style>
@import "../../css/Portal_base_infographics.css";

</style>

<script>
import svg_elements from "@/assets/svg_elements";
import { gsap } from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger)

export default {
  components: {
    svg_elements,
  },
  data () {
    return {
      
    }
  },
  methods: {
    startMaintitle() {
      gsap.fromTo('.infographics_Animation1', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation1",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation2', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation2",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation3', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation3",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.3,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation4', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation4",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation5', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation5",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.3,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation6', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation6",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation7', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation7",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.3,
          opacity: 1,
        }
      ),
      gsap.fromTo('.infographics_Animation8', 
        {
          y: 20,
          opacity: 0
        },
        {
          scrollTrigger: {
              trigger: ".infographics_Animation8",
          },
          y: 0,
          x: 0,
          duration: 1,
          ease:"power2.easeInOut",
          delay: 1.6,
          opacity: 1,
        }
      )
    }
  },
  mounted() {
    const hash = this.$route.hash;
    if (hash && hash.match(/^#.+$/)) {
      this.$scrollTo(hash);
    }
    this.startMaintitle()
  }
}

</script>
